export interface LogoProps {
	width?: number;
	height?: number;
	className?: string;
}

// RouterBench logo mark — converging router (many inputs → hub → one output).
// Square, monochrome; inherits currentColor. Callers render the "RouterBench"
// wordmark separately.
const Logo = ({ width, height, className }: LogoProps) => {
	return (
		<svg
			viewBox="0 0 48 48"
			width={width}
			height={height}
			className={className}
			role="img"
			aria-label="RouterBench"
			fill="none"
		>
			<g
				stroke="currentColor"
				strokeWidth={2.6}
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<path d="M9 13 C18 13 20 24 27 24" />
				<path d="M9 24 H27" />
				<path d="M9 35 C18 35 20 24 27 24" />
				<path d="M27 24 H39" />
				<circle cx="9" cy="13" r="2.4" fill="currentColor" />
				<circle cx="9" cy="24" r="2.4" fill="currentColor" />
				<circle cx="9" cy="35" r="2.4" fill="currentColor" />
				<circle cx="27" cy="24" r="3.4" fill="currentColor" />
				<circle cx="39" cy="24" r="2.4" fill="currentColor" />
			</g>
		</svg>
	);
};

export default Logo;
